import { useEffect, useState } from 'react';

// Perfil/escopo DRE do usuário logado (tb_dim_gerente), resolvido no servidor.
// isGerente decide se a feature aparece; escopo ('regional' | 'unidade') decide
// qual visão renderizar. Não confundir com useUserAccess (papéis de documentos).
export function useDreAccess() {
  const [state, setState] = useState({
    loading: true,
    isGerente: false,
    escopo: null,   // 'regional' | 'unidade'
    chave: null,    // regiao ou filial_chave
    regiao: null,
    tipo: null
  });

  useEffect(() => {
    fetch('/api/getDreProfile')
      .then(res => res.json())
      .then(data => {
        setState({
          loading: false,
          isGerente: data.isGerente === true,
          escopo: data.escopo || null,
          chave: data.chave || null,
          regiao: data.regiao || null,
          tipo: data.tipo || null
        });
      })
      .catch(() => setState(prev => ({ ...prev, loading: false })));
  }, []);

  return state;
}
